<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        
        <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'ni ni-shop text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Overview', path: '/dashboard' }"
          ></sidebar-item>
          <sidebar-item v-if="$user.partner_id == null"
            :link="{ name: 'Daily Stats', path: '/dashboard/daily-stats' }"
          ></sidebar-item>
          <sidebar-item v-if="$user.partner_id == null"
            :link="{ name: 'Status Breakdown', path: '/dashboard/status-breakdown' }"
          ></sidebar-item>
        </sidebar-item>

<!--        <sidebar-item :link="{-->
<!--                  name: 'Examples',-->
<!--                  icon: 'ni ni-ungroup text-orange'-->
<!--                  }">-->
<!--          <sidebar-item :link="{ name: 'Pricing', path: '/pricing' }"/>-->
<!--          <sidebar-item :link="{ name: 'Login', path: '/login' }"/>-->
<!--          <sidebar-item :link="{ name: 'Register', path: '/register' }"/>-->
<!--          <sidebar-item :link="{ name: 'Lock', path: '/lock' }"/>-->
<!--          <sidebar-item :link="{ name: 'Timeline', path: '/pages/timeline' }"/>-->
<!--          <sidebar-item :link="{ name: 'Profile', path: '/pages/user' }"/>-->
<!--        </sidebar-item>-->

<!--        <sidebar-item :link="{-->
<!--                  name: 'Components',-->
<!--                  icon: 'ni ni-ui-04 text-info'-->
<!--                }">-->
<!--          <sidebar-item :link="{ name: 'Buttons', path: '/components/buttons' }"/>-->
<!--          <sidebar-item :link="{ name: 'Cards', path: '/components/cards' }"/>-->
<!--          <sidebar-item :link="{ name: 'Grid', path: '/components/grid-system' }"/>-->
<!--          <sidebar-item :link="{ name: 'Notifications', path: '/components/notifications' }"/>-->
<!--          <sidebar-item :link="{ name: 'Icons', path: '/components/icons' }"/>-->
<!--          <sidebar-item :link="{ name: 'Typography', path: '/components/typography' }"/>-->

<!--          <sidebar-item :link="{ name: 'Multi Level' }">-->
<!--            <sidebar-item :link="{ name: 'Third level menu', path:'#!' }"/>-->
<!--            <sidebar-item :link="{ name: 'Just another link', path:'#a' }"/>-->
<!--            <sidebar-item :link="{ name: 'One last link', path:'#b' }"/>-->
<!--          </sidebar-item>-->
<!--        </sidebar-item>-->
<!--        <sidebar-item :link="{-->
<!--                        name: 'Forms',-->
<!--                        icon: 'ni ni-single-copy-04 text-pink'-->
<!--                      }">-->
<!--          <sidebar-item :link="{ name: 'Elements', path: '/forms/elements' }"/>-->
<!--          <sidebar-item :link="{ name: 'Components', path: '/forms/components' }"/>-->
<!--          <sidebar-item :link="{ name: 'Validation', path: '/forms/validation' }"/>-->
<!--        </sidebar-item>-->

        <sidebar-item 
          v-if="$can('view', 'leads')"
          :link="{
          
            name: 'Leads',
            icon: 'ni ni-single-02 text-default'
          }">
          <sidebar-item :link="{ name: 'Leads', path: '/leads' }"/>
          <sidebar-item :link="{ name: 'Contact Enquiries', path: '/contact' }" v-if="$can('view', 'contact_enquiries')"/>
        </sidebar-item>

        <sidebar-item
          v-if="$can('view', 'applications')"
                :link="{
            name: 'Applications',
            icon: 'ni ni-single-copy-04 text-green',
            path: '/applications'
          }">
        </sidebar-item>

        <sidebar-item
            v-if="$can('view', 'pos_applications')"
                :link="{
            name: 'POS Applications',
            icon: 'ni ni-credit-card',
            path: '/pos-applications'
          }">
        </sidebar-item>

<!--        <sidebar-item :link="{-->
<!--                        name: 'Companies Information',-->
<!--                        icon: 'ni ni-archive-2 text-primary'-->
<!--                      }">-->
<!--          <sidebar-item :link="{ name: 'Companies', path: '/companies' }"/>-->
<!--          <sidebar-item :link="{ name: 'Directors', path: '/directors' }"/>-->
<!--          <sidebar-item :link="{ name: 'Websites', path: '/websites' }"/>-->
<!--&lt;!&ndash;          <sidebar-item :link="{ name: 'Platforms', path: '/support-topics' }"/>&ndash;&gt;-->
<!--        </sidebar-item>-->
<!--        <sidebar-item :link="{-->
<!--                        name: 'Website Content',-->
<!--                        icon: 'ni ni-laptop text-primary'-->
<!--                      }">-->
<!--          <sidebar-item :link="{ name: 'Blog', path: '/blog' }"/>-->
<!--          <sidebar-item :link="{ name: 'Careers', path: '/careers' }"/>-->
<!--          <sidebar-item :link="{ name: 'White Papers', path: '/white-papers' }"/>-->
<!--          <sidebar-item :link="{ name: 'Support Topics', path: '/support-topics' }"/>-->
<!--        </sidebar-item>-->
<!--        <sidebar-item-->
<!--          :link="{-->
<!--            name: 'Widgets',-->
<!--            icon: 'ni ni-archive-2 text-green',-->
<!--            path: '/widgets'-->
<!--          }">-->
<!--        </sidebar-item>-->
<!--        <sidebar-item-->
<!--          :link="{-->
<!--            name: 'Reports',-->
<!--            icon: 'ni ni-chart-pie-35 text-info',-->
<!--            path: '/charts'-->
<!--          }">-->
<!--        </sidebar-item>-->

<!--        <sidebar-item-->
<!--          :link="{-->
<!--            name: 'Calendar',-->
<!--            icon: 'ni ni-calendar-grid-58 text-red',-->
<!--            path: '/calendar'-->
<!--          }">-->
<!--        </sidebar-item>-->
      </template>

      <template slot="links-after">
        <hr class="my-3">

        <!--<h6 class="navbar-heading p-0 text-muted" v-if="$can('create', 'users')">Admin</h6>-->

        <ul class="navbar-nav mb-md-3">
          <sidebar-item
            v-if="$can('view', 'users')"
            :link="{
              name: 'Users',
              icon: 'fa fa-users',
              path: '/users',
            }">
          </sidebar-item>

          <sidebar-item
            v-if="$can('view', 'partners')"
            :link="{
              name: 'Partners',
              icon: 'ni ni-briefcase-24',
              path: '/partners',
            }">
          </sidebar-item>

          <sidebar-item
            v-if="$can('view', 'activities')"
            :link="{
              name: 'Activity Log',
              icon: 'ni ni-archive-2 text-blue',
              path: '/activities'
            }">
          </sidebar-item>
          <!-- <li class="nav-item" v-if="$can('view', 'partners')">
            <a class="nav-link"
                href="/partners">
              <i class="fas fa-handshake"></i>
              <span class="nav-link-text">Partners</span>
            </a>
          </li> -->
          <!-- <li class="nav-item">
            <a class="nav-link"
                href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation/components/avatars.html"
                target="_blank">
              <i class="ni ni-ui-04"></i>
              <span class="nav-link-text">Integrations</span>
            </a>
          </li> -->
        </ul>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('scrollbar-inner');
        }
      },
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
